import React, { useEffect, useContext, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import UI_Header from '../components/UI_Header';
import UI_Ribbon_Main from '../components/UI_Ribbon_Main';
import UI_NavigationRail from '../components/ERUMAUI/UI_NavigationRail';
import { useAccounts } from '../Contexts/Context_Accounts';
import { useAuth } from '../Contexts/AuthContext';
import { useTemplating } from '../Contexts/Context_Templating';
import { useReporting } from '../Contexts/Context_Reporter';
import { Context_UI } from '../Contexts/Context_UI';
import { useStatus } from '../Contexts/Context_Status_Global';
import Context_Provider_Progressor from '../Contexts/Context_Progressor';

import Panel_Reporter_Center from '../components/Reporting/Panel_Reporter_Center';
import Panel_Reporter_Left from '../components/Reporting/Panel_Reporter_Left';
import Panel_Reporter_Right from '../components/Reporting/Panel_Reporter_Right';

import UI_Slide_Manager from '../components/ERUMAUI/UI_Slide_Manager';
import UI_Subwindow_Manager from '../components/ERUMAUI/UI_Subwindow_Manager';
import UI_Icon from '../components/ERUMAUI/UI_Icons';

import Icon_Arrow_Left from '../Assets/Icons/Icon_Arrow_Left.png';
import Icon_Reports from '../Assets/Icons/Icon_Reports.png';
import Icon_Calendar from '../Assets/Icons/Icon_Calendar.png';
import Icon_Table from '../Assets/Icons/Icon_Table.png';
import Icon_Room from '../Assets/Icons/Icon_Room.png';
import Icon_Map from '../Assets/Icons/Icon_Map.png';
import Icon_ReservationSlip from '../Assets/Icons/Icon_ReservationSlip.png';
import Icon_User from '../Assets/Icons/Icon_User.png';
import Icon_Trail from '../Assets/Icons/Icon_Trail.png';
import Icon_PDF from '../Assets/Icons/Icon_PDF.png';
import Icon_Image from '../Assets/Icons/Icon_Image.png';
import Icon_Print from '../Assets/Icons/Icon_Print.png';

import Subwindow_Modal_UnsavedChanges from '../components/Subwindow_Modal_UnsavedChanges';
import Subwindow_Modal_Report_Export from '../components/Reporting/Subwindow_Reporting_Export';
import Subwindow_Modal_Report_Export_Processing from '../components/Reporting/Subwindow_Reporting_Export_Processing';
import Subwindow_Map_Chooseroom from '../components/InteractiveMap/Subwindow_Map_ChooseRoom';
import Subwindow_Accounts_Choose from '../components/AccountManagement/Subwindow_Accounts_Choose';


export default function DR_Main() {
    const UI = useContext(Context_UI);
    const navigate = useNavigate();
    const location = useLocation();
    const { Slide_Switch } = useStatus();
    const { Account, Loading, Logout } = useAuth();
    const { User_Permission } = useAccounts();
    const { Templates_Edit_Save_Attempt, Template_Editor_Unsaved } = useTemplating();
    const { Report_Orientation, Export_AsPDF, Export_AsImage, Export_AsPrintable } = useReporting();

    useEffect(() => {
        UI.Page_Navigator_Set(navigate);
        // UI.Initialize();
        UI.LoadingScreen_Hide("Screen_Loading");
    }, []);

    useEffect(() => {
        // console.log(Account?.Access.Reservation.Create);
    }, [location.pathname]);

    // Match Slide_ID with a slide property on App_Properties.
    const [Composition_Slide, Composition_Slide_Set] = useState([]);
    const [Template_Save, Template_Save_Set] = useState({ State: false });
    useEffect(() => {
        console.log(Template_Editor_Unsaved);
        if (Template_Editor_Unsaved) {
            Template_Save_Set({ State: true });
        } else {
            Template_Save_Set({ State: false });
        }
    }, [Template_Editor_Unsaved]);

    const [Composition_Navigation, Composition_Navigation_Set] = useState(null);


    useEffect(() => {
        Composition_Slide_Set([
            {
                Slide_ID: "Reporter",
                Panel_Left: <Panel_Reporter_Left />,
                Panel_Center: <Panel_Reporter_Center />,
                Panel_Right: <Panel_Reporter_Right />,
                Active: () => true,
                Ribbon: {
                    Active: () => true,
                    Contents: [
                        {
                            Icon: Icon_PDF,
                            Text: "Save as PDF",
                            Destination: "",
                            Action: () => Export_AsPDF(),
                            Active: () => true
                        },
                        {
                            Icon: Icon_Image,
                            Text: "Save as image",
                            Destination: "",
                            Action: () => Export_AsImage(),
                            Active: () => true
                        },
                        {
                            Icon: Icon_Print,
                            Text: "Print document",
                            Destination: "",
                            Action: () => Export_AsPrintable(),
                            Active: () => true
                        }
                    ]
                }
            }
        ]);
        Composition_Navigation_Set([
            {
                Routes: ["/"],
                Destination: "/reports",
                Icon: Icon_Arrow_Left,
                Text: "Exit editor",
                hasBadge: false,
                LoadingScreen: false,
                Active: () => true
            },
            {
                Routes: ["/reports/monthlysched", "/reports/timetable", "/reports/roomutil", "/reports/floorutil", "/reports/reservation", "/reports/accounts", "/reports/log"],
                Destination: "/reports/monthlysched",
                Icon: Icon_Calendar,
                Text: "Monthly schedule",
                hasBadge: false,
                LoadingScreen: false,
                Active: () => Account?.Access?.Report?.ActivityLog
            },
            {
                Routes: ["/reports/monthlysched", "/reports/timetable", "/reports/roomutil", "/reports/floorutil", "/reports/reservation", "/reports/accounts", "/reports/log"],
                Destination: "/reports/timetable",
                Icon: Icon_Table,
                Text: "Schedule timetable",
                hasBadge: false,
                LoadingScreen: false,
                Active: () => Account?.Access?.Report?.ScheduleTimetable
            },
            {
                Routes: ["/reports/monthlysched", "/reports/timetable", "/reports/roomutil", "/reports/floorutil", "/reports/reservation", "/reports/accounts", "/reports/log"],
                Destination: "/reports/floorutil",
                Icon: Icon_Map,
                Text: "Map overview",
                hasBadge: false,
                LoadingScreen: false,
                Active: () => Account?.Access?.Report?.MapOverview
            },
            {
                Routes: ["/reports/monthlysched", "/reports/timetable", "/reports/roomutil", "/reports/floorutil", "/reports/reservation", "/reports/accounts", "/reports/log"],
                Destination: "/reports/reservation",
                Icon: Icon_ReservationSlip,
                Text: "Reservation slip",
                hasBadge: false,
                LoadingScreen: false,
                Active: () => Account?.Access?.Report?.ReservationSlip
            },
            {
                Routes: ["/reports/monthlysched", "/reports/timetable", "/reports/roomutil", "/reports/floorutil", "/reports/reservation", "/reports/accounts", "/reports/log"],
                Destination: "/reports/accounts",
                Icon: Icon_User,
                Text: "Accounts list",
                hasBadge: false,
                LoadingScreen: false,
                Active: () => Account?.Access?.Report?.AccountList
            },
            {
                Routes: ["/reports/usertrail", "/reports/timetable", "/reports/roomutil", "/reports/floorutil", "/reports/reservation", "/reports/accounts", "/reports/log"],
                Destination: "/reports/usertrail",
                Icon: Icon_Trail,
                Text: "User trail",
                hasBadge: false,
                LoadingScreen: false,
                Active: () => Account?.Access?.Report?.AccountList
            },
            {
                Routes: ["/reports/monthlysched", "/reports/timetable", "/reports/roomutil", "/reports/floorutil", "/reports/reservation", "/reports/accounts", "/reports/log"],
                Destination: "/reports/roomutil",
                Icon: Icon_Room,
                Text: "Room utilization",
                hasBadge: false,
                LoadingScreen: false,
                Active: () => Account?.Access?.Report?.RoomUtilization
            },
            {
                Routes: ["/reports/monthlysched", "/reports/timetable", "/reports/roomutil", "/reports/floorutil", "/reports/reservation", "/reports/accounts", "/reports/log"],
                Destination: "/reports/log",
                Icon: Icon_Reports,
                Text: "Activity logs",
                hasBadge: false,
                LoadingScreen: false,
                Active: () => Account?.Access?.Report?.ActivityLog
            }
        ])
    }, [Account, location.pathname]);

    // Define all the subwindows the page's slides use
    const [Composition_Subwindow, Composition_Subwindow_Set] = useState([
        {
            ID: "Window_General_UnsavedChanges",
            Component: <Subwindow_Modal_UnsavedChanges />
        },
        {
            ID: "Window_Report_Export",
            Component: <Subwindow_Modal_Report_Export />
        },
        {
            ID: "Window_Map_ChooseRoom",
            Component: <Subwindow_Map_Chooseroom />
        },
        {
            ID: "Window_Accounts_ChooseRoom",
            Component: <Subwindow_Accounts_Choose />
        },
        {
            ID: "Window_Report_Export_Processing",
            Component: <Subwindow_Modal_Report_Export_Processing />
        }
    ]);

    return (

        <ui-main>

            <UI_Subwindow_Manager Composition={Composition_Subwindow} />

            <UI_Header />
            <UI_NavigationRail Composition={Composition_Navigation} />
            <UI_Slide_Manager Composition={Composition_Slide} />
        </ui-main>



    )
}